
export interface ISignUp {
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
}

export const signUpInit: ISignUp = {
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
};
